<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('purchaseOrder.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('purchaseOrder.pageTitle'),
            href: '/admin/purchase-orders'
          },
          {
            text: $t('create'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <ts-loading-banner :loading="loading">
          <form class="form-horizontal ts-space-y-3">
            <div class="row">
              <div class="col-md-12">
                <Info
                  v-model="model"
                  :validate="errors"
                  class="tw-p-3 tw-rounded"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <ItemList
                  v-model="model"
                  :validate="errors"
                  class="ts-border ts-rounded"
                />
              </div>
            </div>
            <div class="row ts-mt-4">
              <div
                class="col-md-12 ts-flex ts-items-center ts-space-x-3 ts-justify-end"
              >
                <ts-button
                  @click.prevent="$router.push({ name: 'purchase-order' })"
                  >{{ $t('cancel') }}</ts-button
                >
                <ts-button
                  color="primary"
                  outline
                  :waiting="waiting_new"
                  @click.prevent="onSaveAddNew"
                  >{{ $t('savePrint') }}</ts-button
                >
                <ts-button
                  :waiting="waiting"
                  @click.prevent="onSave"
                  color="primary"
                  >{{ $t('save') }}</ts-button
                >
              </div>
            </div>
          </form>
          <a-modal
            :title="$t('pdf')"
            width="50%"
            v-model="show_pdf"
            :footer="null"
          >
            <ts-preview-pdf v-model="waiting" :src="src" />
          </a-modal>
        </ts-loading-banner>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { Errors } from 'form-backend-validation'
import moment from 'moment'
import Info from './components/purchase-order-info.vue'
import ItemList from './components/item-list'

export default {
  name: 'purchaseOrderCreate',
  components: {
    Info,
    ItemList
  },
  data () {
    return {
      loading: false,
      waiting_new: false,
      waiting: false,
      show_pdf: false,
      src: '',
      errors: new Errors(),
      model: {
        po_date: moment().format('DD-MM-YYYY'),
        vendor_id: null,
        description: null,
        reference_no: null,
        purchase_type_id: null,
        fx_rate_khr: null,
        fx_rate_thb: null,
        credit_day: 0,
        po_detail: []
      }
    }
  },
  created () {
    this.fetchData()
  },
  computed: {
    supplierList () {
      return this.$store.state.purchaseOrder.order.suppliers.map(el => ({
        value: el.vendor_id,
        label: el.vendor_name
      }))
    }
  },
  methods: {
    ...mapActions('purchaseOrder/order', [
      'getSupplier',
      'getProduct',
      'getMeasure',
      'getPurchaseType',
      'getexFx',
      'store'
    ]),
    async fetchData () {
      this.loading = true
      await this.getSupplier()
      await this.getProduct()
      await this.getMeasure()
      await this.getPurchaseType()
      await this.setExchangeRate()
      this.loading = false
    },
    async setExchangeRate () {
      await this.getexFx()
      // hide because we will update to v2
      // let fxRate = this.$store.state.purchaseOrder.order.exchangeRate.find(
      //   e => e.to_currency == 'KHR'
      // )
      // if (fxRate) {
      //   this.model.fx_rate_khr = parseFloat(fxRate.fx_rate)
      // }
      let fxRate = this.$store.state.purchaseOrder.order.exchangeRate.find(
        e => e.to_currency == 'KHR'
      )
      if (fxRate) {
        this.model.fx_rate_khr = parseFloat(fxRate.fx_rate)
      }
      let fxUSD = this.$store.state.purchaseOrder.order.exchangeRate.find(
        e => e.to_currency == 'USD'
      )
      if (fxUSD) {
        this.model.fx_rate_thb = parseFloat(fxUSD.fx_rate)
      }
    },
    onSave () {
      this.waiting = true
      this.errors = new Errors()
      this.store(this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.clearInput()
          this.$router.push({ name: 'purchase-order' })
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    onSaveAddNew () {
      this.waiting_new = true
      this.show_pdf = true
      this.errors = new Errors()
      this.store(this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.src = response.url
          this.clearInput()
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
          this.show_pdf = false
        })
        .finally(() => {
          this.waiting_new = false
        })
    },
    clearInput () {
      this.model.po_date = moment().format('DD-MM-YYYY')
      this.model.vendor_id = null
      this.model.description = null
      this.model.reference_no = null
      this.model.purchase_type_id = null
      this.model.fx_rate_khr = null
      this.model.fx_rate_thb = null
      this.model.credit_day = 0
      this.model.po_detail = []
    }
  },
  beforeRouteLeave (to, from, next) {
    this.$store.commit('purchaseOrder/order/CLEAR_SETUP')
    next()
  }
}
</script>
